<template>
  <div class="box-layout">

    <p class="title">{{ title }}</p>

    <slot>
    </slot>

  </div>
</template>

<script>
export default {
  name: 'LayoutTwoColumn',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.box-layout:first-child {
  margin-top: 50px;
}

.box-layout {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  flex-direction: row;

  margin-top: 20px;
  max-width: 540px;
  padding: 0 20px;
  box-sizing: border-box;

  .title {
    text-align: left;
    font-size: 15px;
    width: 150px;
    margin: 0;
    color: #666666;

    min-width: 150px;
  }
}

@media screen and (max-width: 1024px) {
  .box-layout {
    width: 100%;

    .title {
      min-width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/LayoutTwoColumn.vue